<template>
    <b-container class="pl-0 pr-0">
        <b-col lg="12" class="no-gutters">

            <b-row v-if="!editMode">
                <campaign-item
                    v-for="campaign in results"
                    :key="campaign.id"
                    :campaign="campaign"
                    :show-donate="false"
                    :editable="editable"
                    @edit="editCampaign"
                    @onClicked="showCampaign"/>
            </b-row>

           <b-row v-if="editMode">
              <transition name="fade">
                  <campaign-editor
                          :campaign="campaign"
                          @close="showList"
                          @closeAndUpdate="closeAndUpdate"
                          @alert="showAlert"
                  />
              </transition>
           </b-row>

          <b-row v-if="!loading && !editMode && (!results || results.length < 1)">
            <span class="col-12 no-results">
                    {{ $t('campaign.no_campaigns') }}
            </span>
          </b-row>

            <div v-if="loading" id="loader" class="spinner"/>
        </b-col>
    </b-container>
</template>


<script>

    import CampaignEditor from "./CampaignEditor"
    import FairApi from '../../modules/api'
    import {userHelper} from "../../mixins/UserMixin";
    import CampaignItem from "./CampaignItem";

    export default {
        name: 'campaigns',
        mixins: [userHelper],
        components: {CampaignItem, CampaignEditor},
        props: {
            editable: {
                type: Boolean,
                default: function () {
                    return false
                }
            },
            active: {
                type: Boolean,
                default: function (){
                    return true
                }
            }
        },
        data: function () {
            return {
                results: [],
                campaign: null,
                editMode: false,
                loading: false
            }
        },
        created: function () {
            this.fetchCampaigns()
        },

        methods: {
            fetchCampaigns: function () {
                this.loading = true
                let params
                if (this.active) {
                    let date = new Date();
                    date.setHours(23, 59, 59)
                    params = {organization: this.$store.state.user.organization ? this.$store.state.user.organization.id : null,
                        active: this.active, end_date_from: date.toISOString()}
                    FairApi.getWithParams(FairApi.campaign(),
                        params,
                        this.success, this.failed)
                } else {
                    FairApi.get(FairApi.campaignClosed(), this.success, this.failed)
                }
            },

            success: function (response) {
                this.results = response
                this.loading = false
            },

            failed: function () {
                this.loading = false
                this.showAlert(this.$t('common.fetch_failed'))
            },

            addCampaign: function () {
                if (this.$store.state.user.organization && this.campaign === null) {
                    this.editMode = true
                    this.$emit('onEditing')
                }
            },

            editCampaign: function (campaign) {
                if (this.$store.state.user.organization) {
                    this.campaign = campaign
                    this.editMode = true
                    this.$emit('onEditing')
                }
            },

            showList: function () {
                this.campaign = null
                this.editMode = false
                this.$emit('onEditingDone')
            },

            showAlert: function (msg) {
                this.$emit('alert', msg)
            },

            closeAndUpdate: function () {
                this.showList()
                this.fetchCampaigns()
            },

            showCampaign(campaign) {
                this.$router.push({name: 'campaign-info-view', params: {id: campaign.id}})
            }
        }
    }
</script>
